import { TextField } from "@mui/material";
import { useTheme } from "@mui/styles";
import React from "react";

const TextInput = ({ styles = {}, onChange = () => {}, value, ...props }) => {
  const theme = useTheme();
  const handleOnChange = event => {
    onChange(event.target.value);
  };

  return (
    <TextField
      size="small"
      variant="outlined"
      onChange={handleOnChange}
      value={value}
      sx={{
        ":hover": {
          borderColor: theme.COLORS.GREEN.green,
        },
        fullWidth: true,
        ...styles,
      }}
      {...props}
    />
  );
};

export default TextInput;
